import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeUserFromGroups } from '../api/USERS/users';
import { toast } from 'react-toastify';

export const useRemoveUserFromGroups = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, groupIds }) => removeUserFromGroups(userId, groupIds),
    onSuccess: (data, variables) => {
      // Invalider le cache pour recharger les données de l'utilisateur
      queryClient.invalidateQueries({ queryKey: ['user', variables.userId] });
      queryClient.invalidateQueries({ queryKey: ['users'] });
      toast.success('Utilisateur retiré du groupe avec succès');
    },
    onError: (error) => {
      toast.error(error.message || 'Erreur lors du retrait du groupe');
    }
  });
};
